import { Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "./header";
import { Footer } from "./footer";
import { TopBar } from "./top-bar";

export function SiteLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-white focus:shadow-lg focus:outline-none"
      >
        Skip to main content
      </a>
      <TopBar />
      <Header />
      <main id="main-content" className="flex-1" role="main">
        {children ?? <Outlet />}
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
